/* eslint-disable max-lines */
import { CommonModule, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BookWidgetFieldUpdateTypes } from '../../../../constants/book-widget.constants';

import {
  BestFareOptionsMachCoreComponent,
  ConnectionPickerMachCoreComponent,
  DatePickerMachCoreComponent,
  MeetingCodeMachCoreComponent,
  MulticityRoutePickerMachCoreComponent,
  SelectMachCoreComponent
} from '../../../common';

import { BookWidgetFieldUpdateEvent } from '../../../../models/book-widget-fields-update-info.interfaces';
import { ModifyBookWidgetBaseComponent } from '../modify-book-widget-base/modify-book-widget-base.component';

@Component({
  standalone: true,
  selector: 'idp-multi-city-desktop-modify',
  templateUrl: './multi-city-desktop-modify.component.html',
  imports: [
    CommonModule,
    MulticityRoutePickerMachCoreComponent,
    ConnectionPickerMachCoreComponent,
    DatePickerMachCoreComponent,
    SelectMachCoreComponent,
    BestFareOptionsMachCoreComponent,
    MeetingCodeMachCoreComponent,
    NgClass
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MulticityDesktopModifyComponent extends ModifyBookWidgetBaseComponent {
  clearConnectionAirport(flightIndex: number) {
    const emitValue: BookWidgetFieldUpdateEvent = {
      data: {
        airportCode: '',
        airportCity: '',
        flightIndex
      },
      type: BookWidgetFieldUpdateTypes.connectionAirport
    };
    this.bookWidgetFieldChange.emit(emitValue);
  }
}
